module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-10-8fb812c18cf9882b6077c29cfade13e7.webp";